import identity from "lodash/fp/identity";

class TickettypesPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default TickettypesPageTransform;



// WEBPACK FOOTER //
// ./src/pages/tickettypes/tickettypes.transforms.js